import React, { useMemo, useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
// Temporarily disabled: CAPA feature (ArrowRightOutlined only used by CAPA buttons)
// import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { has, isEmpty } from "lodash";
import moment from "moment";
import { toast } from "react-toastify";

// Temporarily disabled: CAPA feature (CSS clashes when statically imported)
// import SuccessMessage from "../../../../CAPA/components/SuccessMessage";
// import CorrectiveActionModal from "../../../../CAPA/CorrectiveActionModal";
// import RetestButton from "./RetestButton";

import { TEMPLATE_SIDES } from "../../../../../Common/Template/TemplateContext";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import CoaPreviewModal from "../../../../../Product/Report/Components/Preview/CoaPreviewModal";
import {
  downloadCoaFromS3Paths,
  fetchEnvCoaPreviewFromTemplate,
  normalizeEnvReportPathList,
} from "../../Preview/envCoaPreviewHelper";

import { downloadFileFromS3WithPresigned } from "../../../../../../utils/helpers";
import { hasPermission, permissions } from "../../../../../../utils/Permissions";

import { envGeneratePartialReport } from "../../../../../../actions/envAnalytics";
// Temporarily disabled: CAPA feature
// import { endEnvCorrectivePlan } from "../../../../../../actions/envCorrectiveAction";

import { ReactComponent as DownloadIcon } from "../../../../../../assets/images/environment/downloadIcon.svg";
import { ReactComponent as HistoryIcon } from "../../../../../../assets/images/environment/historyIcon.svg";
import { ReactComponent as PreviewIcon } from "../../../../../../assets/images/environment/previewIcon.svg";

import "./ResultActions.css";

export default function ResultActions({
  report,
  specsData,
  // identifier,
  // handlePreviewFile, // preview currently opens CoaPreviewModal locally
  // handleCustomizedCoaDownload,  // FUTURE PROD: customized COA download with template picker sidebar
  // handleAddSpecsButton,
  path,
  setShowReportHistory,
  reportSpecData,
  // imageSrc,
  // pinMap,
  // index0,
  // selectedLocationID,
  // indexOfQuadrantHoverOver,
  // loadingMap,
  // setSelectedLocationID,
  // setDisplayTooltipLocationID,
  // transformWrapperRef,
  // togglePinningNewSwab,
  // clickQuadrant,
  // isClickingQuadrant,
  // displayNoResultFound,
  // displayTooltipLocationID,
  // mapKey,
  // updatePinsList,
  // mapTitle,
  // planId,
  // upcomingDates,
  // caPaths,
  // selectedReportTabDate,
  // refetchSpecs,
  isGeneratingPartial,
  toggleGeneratePartial,
  loadingSpecData,
  testCheckboxVals,
  setTestCheckboxVals,
  carouselRetestDate,
  reportPathExists,
  getTestValGrouped,
}) {
  // Temporarily disabled: CAPA feature
  // const [isCorrectiveActionModalVisible, setIsCorrectiveActionModalVisible] = useState(false);
  // const [showEndCorrectiveActionModal, setShowEndCorrectiveActionModal] = useState(false);
  // const [correctiveActionCreationSuccess, setCorrectiveActionCreationSuccess] = useState(false);
  // const [endCorrectivePlanLoading, setEndCorrectivePlanLoading] = useState(false);
  const [loadingPartialGenerate, setLoadingPartialGenerate] = useState(false);
  const [isDownloadingCoa, setIsDownloadingCoa] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const { areResultsLocked } = useAccessStatus();
  const hasCoaPath = Object.keys(path || {}).length > 0;
  const enableCoaActions = hasCoaPath && !areResultsLocked;

  const loadEnvironmentTemplatePreview = (template, signal) => (
    fetchEnvCoaPreviewFromTemplate({
      templateId: template.template_id,
      report,
      specsData,
      activeDate: carouselRetestDate,
      signal,
    })
  );

  /**
   * In case of successfully creating corrective action, the success modal should be hidden automatically
   * Default timeout = 2s
   */
  // Temporarily disabled: CAPA feature
  // useEffect(() => {
  //   if (correctiveActionCreationSuccess) {
  //     setTimeout(() => {
  //       setCorrectiveActionCreationSuccess(false);
  //     }, 2000);
  //   }
  // }, [correctiveActionCreationSuccess]);

  const handleDownloadFile = async (filePath) => {
    if (areResultsLocked || isDownloadingCoa) {
      return;
    }
    if (!filePath || Object.keys(filePath).length < 1) {
      toast.error("Unable to download, no valid file path for this report!");
      return;
    }
    const s3Paths = normalizeEnvReportPathList(filePath);
    if (!s3Paths.length) {
      toast.error("Unable to download, no valid file path for this report!");
      return;
    }
    setIsDownloadingCoa(true);
    try {
      const { totalFiles, filesDownloaded } = await downloadCoaFromS3Paths(s3Paths);
      if (filesDownloaded === totalFiles && totalFiles > 0) {
        toast.success(`Successfully downloaded ${filesDownloaded}/${totalFiles} files.`);
      } else if (filesDownloaded > 0) {
        toast.warning(`Downloaded ${filesDownloaded}/${totalFiles} files.`);
      } else {
        toast.error("Failed to download report files.");
      }
    } catch (error) {
      toast.error(error.message || "Failed to download report files.");
    } finally {
      setIsDownloadingCoa(false);
    }
  };

  /**
   * Show corrective action success message
   */
  // Temporarily disabled: CAPA feature
  // const showSuccessMessage = () => {
  //   setCorrectiveActionCreationSuccess(true);
  // };

  /**
   * Handle end corrective action api call
   */
  // Temporarily disabled: CAPA feature
  // const handleEndCorrectiveAction = async () => {
  //   setEndCorrectivePlanLoading(true);
  //   const response = await endEnvCorrectivePlan(planId);
  //   toast(response.success ? "Successfully ended corrective action plan" : response.message, { type: response.success ? "success" : "error" });
  //   setEndCorrectivePlanLoading(false);
  //   setShowEndCorrectiveActionModal(false);
  //   updatePinsList(); // Update pins
  // };

  /**
   * Handle preview and download action
   * @param {"preview" | "download"} action preview | download
   */
  // const handleReportViewActions = (action) => () => {
  //   let filePaths = "";
  //   if (caPaths && Object.keys(caPaths).length > 0 && selectedReportTabDate in caPaths) { // Selected date is corrective action date
  //     filePaths = { [selectedReportTabDate]: caPaths[selectedReportTabDate] };
  //   } else if (path && Object.keys(path).length > 0 && selectedReportTabDate in path) { // selected date is not corrective action date
  //     filePaths = path;
  //   }

  //   if (action === "preview") {
  //     handlePreviewFile(filePaths);
  //   } else {
  //     handleDownloadFile(filePaths);
  //   }
  // };

  /*
    * Download partial reports
    * @param {*} fileArray Array for file objects
    */
  const handleDownloadPartialReports = async (fileArray) => {
    if (!fileArray || fileArray?.length === 0) {
      toast.error("Failed to download Partial Report");
      return;
    }
    const downloadFilePromises = fileArray.map((file) => {
      const fileName = file ? file.split("/").pop() : "";
      const isPrivateS3Bucket = file.includes("COAs/");
      const bucket = isPrivateS3Bucket ? "private" : "public";
      return downloadFileFromS3WithPresigned([file], bucket, [fileName]);
    });
    const resultsArray = await Promise.all(downloadFilePromises);
    const failedCount = resultsArray.filter((result) => result === false).length;
    const successCount = resultsArray.filter((result) => result === true).length;

    if (successCount === 0) {
      toast.error("Failed to download Partial Report");
    } else if (failedCount === 0) {
      toast.success(`Partial report generated and downloaded successfully ${successCount}/${resultsArray.length}.`);
    } else {
      toast.warning(`Downloaded ${successCount}/${resultsArray.length} files. Some files could not be downloaded.`);
    }
  };

  /**
   * Preview all reports in a single preview modal; Both report and correction action reports
   */
  // Temporarily disabled: CAPA feature (only used by CAPA view button)
  // const handleAllViewCorrectiveReport = () => {
  //   let allPaths = {};
  //   if (path && Object.keys(path).length > 0) allPaths = { ...allPaths, ...path };
  //   if (caPaths && Object.keys(caPaths).length > 0) allPaths = { ...allPaths, ...caPaths };
  //   handlePreviewFile(allPaths);
  // };

  /**
   * Renders corrective action buttons
   */
  // Temporarily disabled: CAPA feature
  const renderCorrectiveActionButtons = () => null;
  // const renderCorrectiveActionButtons = () => {
  //   const initiateButton = (
  //     <Button
  //       type="primary"
  //       className="ResultActions__CAButton"
  //       icon={<ArrowRightOutlined />}
  //       iconPosition="end"
  //       onClick={() => setIsCorrectiveActionModalVisible(true)}
  //     >
  //       Initiate Corrective Action
  //     </Button>
  //   );
  //   const endButton = (
  //     <Button type="default" className="ResultActions__CAButton" onClick={() => setShowEndCorrectiveActionModal(true)}>
  //       End Corrective Action
  //     </Button>
  //   );
  //   const viewButton = (
  //     <Button type="default" className="ResultActions__CAButton text-wrap-auto" onClick={handleAllViewCorrectiveReport}>
  //       View Corrective Report
  //     </Button>
  //   );

  //   // Check if there are corrective action paths and upcoming dates then show both the "End" and "View" buttons
  //   if (Object.keys(caPaths || {}).length > 0 && upcomingDates.length > 0) {
  //     return (
  //       <div className="ResultActions__CAReportViewEndButtons">
  //         {viewButton}
  //         {endButton}
  //       </div>
  //     );
  //   }
  //   // Check if there are corrective action paths but no upcoming dates then show the "View" button
  //   if (Object.keys(caPaths || {}).length > 0 && upcomingDates.length === 0) {
  //     return viewButton;
  //   }
  //   // Check if there are no corrective action paths but there are upcoming dates then show the "End" button
  //   if (Object.keys(caPaths || {}).length === 0 && upcomingDates.length > 0) {
  //     return endButton;
  //   }
  //   // If none of the above conditions are met, show the "Initiate" button
  //   const haveFeatures = hasPermission(permissions.environment.correctiveAction);
  //   if (haveFeatures && ["2", "6"].includes(report.specs_flag)) { // Have above features and test is out of specs
  //     return initiateButton;
  //   }
  //   return null;
  // };

  // const enablePreview = (path && Object.keys(path).length > 0 && selectedReportTabDate in path) || (caPaths && Object.keys(caPaths).length > 0 && selectedReportTabDate in caPaths);

  /*
   * check if any of the row is checked
   */
  const checkedResultCount = useMemo(() => {
    const flat = Object.values(testCheckboxVals || {}).flatMap((items) => items.filter((item) => item.checked));
    return flat.length;
  }, [testCheckboxVals]);

  /**
   * Handles onclick event for generate partial cancel button
   */
  const cancelGeneratePartial = () => {
    toggleGeneratePartial(false);
    setTestCheckboxVals({});
  };

  /**
   * Call api for generate partial report
   */
  const onGenerateSpec = async () => {
    if (!testCheckboxVals || checkedResultCount === 0) return;
    setLoadingPartialGenerate(true);
    try {
      const { sample_id, sample_type, received_date } = report;
      const payload = Object.entries(testCheckboxVals).reduce((acc, [date, checkedDataList]) => {
        const test_list = [];
        checkedDataList.forEach((data) => {
          if (!data.checked) return;
          const { test, test_category } = data.data;
          test_list.push({ test, test_category });
        });
        if (test_list.length > 0) {
          acc.push({
            sample_id,
            sample_type,
            received_date: moment(new Date(received_date)).format("YYYY-MM-DD"),
            date: moment(new Date(date)).format("YYYY-MM-DD"),
            test_list,
          });
        }
        return acc;
      }, []);
      const response = await envGeneratePartialReport(payload);
      if (!response.success) {
        throw new Error(response.message);
      }
      const result = response.result && response.result.length > 0 ? response.result[0] : null;
      if (!result) {
        throw new Error("Result not available");
      }
      if (has(result, "error")) {
        const { error } = result;
        if (typeof error === "object" && Array.isArray(error) && error.length > 0) {
          const errorStr = error.join("\n");
          throw new Error(errorStr);
        }
      }
      if (result.path.length === 0) {
        throw new Error("File not exists");
      }
      await handleDownloadPartialReports(result.path);
      cancelGeneratePartial();
    } catch (error) {
      toast.error(error.message);
    }
    setLoadingPartialGenerate(false);
  };

  /**
   * Handles onclick event for generate partial button
   */
  const handleGeneratePartial = async () => {
    if (areResultsLocked) {
      return;
    }
    if (isGeneratingPartial && checkedResultCount > 0) {
      onGenerateSpec();
    } else {
      setTestCheckboxVals(getTestValGrouped(reportSpecData)); // updating checkbox values for consistent data
      toggleGeneratePartial(true);
    }
  };

  /**
   * get Generate Partial button text
   */
  const generateButtonText = useMemo(() => {
    if (loadingPartialGenerate) return "Generating Partial...";
    if (isGeneratingPartial) {
      return `Generate Partial (${checkedResultCount})`;
    }
    return "Generate Partial";
  }, [loadingPartialGenerate, isGeneratingPartial, checkedResultCount]);

  // If report is available for the date
  const reportAvailable = useMemo(() => {
    if (isEmpty(reportPathExists)) {
      return false;
    }
    return reportPathExists[carouselRetestDate];
  }, [carouselRetestDate, reportPathExists]);

  return (
    <div className="env-report-view-report-section-actions">
      {showPreview && !areResultsLocked && (
        <CoaPreviewModal
          filePaths={path}
          report={report}
          handleCloseForPreview={() => setShowPreview(false)}
          side={TEMPLATE_SIDES.ENVIRONMENTAL}
          loadTemplatePreview={loadEnvironmentTemplatePreview}
        />
      )}
      <div className="env-analytics-view-report-section-actions-buttons">
        <PreviewIcon
          className={enableCoaActions ? "" : "disabledAction"}
          onClick={enableCoaActions ? () => setShowPreview(true) : undefined}
          aria-label={enableCoaActions ? "Preview report" : "Preview unavailable"}
          aria-disabled={!enableCoaActions}
        />
        {isDownloadingCoa ? (
          <LoadingOutlined
            spin
            className="env-report-view-action-loading"
            aria-label="Downloading report"
          />
        ) : (
          <DownloadIcon
            className={enableCoaActions ? "" : "disabledAction"}
            onClick={enableCoaActions ? () => handleDownloadFile(path || {}) : undefined}
            aria-label={enableCoaActions ? "Download report" : "Download unavailable"}
            aria-disabled={!enableCoaActions}
            /* FUTURE PROD: customized COA download with template picker sidebar
              onClick={Object.keys(path).length > 0 ? () => handleCustomizedCoaDownload({
                path: path || {},
                report,
                specsData,
                activeDate: carouselRetestDate,
              }) : () => { }} */
          />
        )}
        {!areResultsLocked && (
          <HistoryIcon
            onClick={() => setShowReportHistory(true)}
          />
        )}
        {renderCorrectiveActionButtons()}
      </div>
      {/* {(report && report.specs_flag === "3")
        && (
        <Button type="primary"
          onClick={() => handleAddSpecsButton(identifier)}
          className="ResultActions__AddSpecsBtn"
        >
          Add Specs
        </Button>
        )} */}
      <div className="ResultActions__GeneratePartialButtons">
        {(isGeneratingPartial && !loadingPartialGenerate) && (
          <Button
            type="default"
            onClick={cancelGeneratePartial}
          >
            Cancel
          </Button>
        )}
        {(hasPermission(permissions.environment.generatePartial) && !areResultsLocked && (!reportAvailable || (isGeneratingPartial && reportAvailable))) && (
        <Button
          type="primary"
          onClick={handleGeneratePartial}
          disabled={loadingSpecData || (isGeneratingPartial && checkedResultCount === 0)}
          loading={loadingPartialGenerate}
        >
          {generateButtonText}
        </Button>
        )}
      </div>
      {/* Temporarily disabled: CAPA feature (CSS clashes when module is imported)
      {isCorrectiveActionModalVisible && (
        <CorrectiveActionModal
          onCancel={() => setIsCorrectiveActionModalVisible(false)}
          showSuccessMessage={showSuccessMessage}
          report={report}
          sampleId={report?.sample_id}
          reportSpecData={reportSpecData}
          imageSrc={imageSrc}
          pinMap={pinMap}
          index0={index0}
          selectedLocationID={selectedLocationID}
          indexOfQuadrantHoverOver={indexOfQuadrantHoverOver}
          loadingMap={loadingMap}
          setSelectedLocationID={setSelectedLocationID}
          setDisplayTooltipLocationID={setDisplayTooltipLocationID}
          transformWrapperRef={transformWrapperRef}
          togglePinningNewSwab={togglePinningNewSwab}
          clickQuadrant={clickQuadrant}
          isClickingQuadrant={isClickingQuadrant}
          displayNoResultFound={displayNoResultFound}
          displayTooltipLocationID={displayTooltipLocationID}
          mapKey={mapKey}
          mapTitle={mapTitle}
          updatePinsList={updatePinsList}
        />
      )}
      {correctiveActionCreationSuccess && (
        <SuccessMessage
          message="Corrective Action Scheduled"
          onCancel={() => setCorrectiveActionCreationSuccess(false)}
        />
      )}
      {showEndCorrectiveActionModal && (
        <EnvConfirmModal
          headerText="End Corrective Action"
          bodyText="All future schedules will be canceled and removed from the calendar."
          buttonText={["Close", "End and remove"]}
          buttonFunctions={[
            () => setShowEndCorrectiveActionModal(false),
            handleEndCorrectiveAction,
          ]}
          loading={endCorrectivePlanLoading}
        />
      )}
  */}
    </div>
  );
}
